/**
 * 导出文献数量限制
 */
export const EXPORT_PAPER_LIMIT = 1000;
